module.exports = __webpack_public_path__ + "img/BLITZ POSITANO-061-retro.cf86e2b4.jpg";